import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { Segment } from '../interfaces/accounting.interface';

export const SegmentService = {
    getByInstitution: async (page = 0, size = 100) => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(`${ENDPOINTS.SEGMENT.LIST_BY_INSTITUTION(institutionId!)}?page=${page}&size=${size}`);
        return res.data; // Page<Segment>
    },
    create: async (segment: Segment) => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.post(ENDPOINTS.SEGMENT.BASE, { ...segment, institutionId });
        return res.data;
    },
    update: async (id: string, segment: Segment) => {
        const res = await axios.put(ENDPOINTS.SEGMENT.UPDATE(id), segment);
        return res.data;
    },
};
